//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilesField from '../../../../components/File/FilesField.vue'
import FilesGroup from '../../../../components/File/FilesGroup.js'
import { journalRecordFilesGroups } from '../../../../components/File/JournalRecordFilesGroups.js'
import Video from '../../../../components/File/Video.vue'
import { axiosPost, AXIOS } from '../../../../axios/axios.js'
import CatalogsRecivier from './CatalogsRecivier.vue'
import { downloadFile } from '../../../../components/helpers.js'
import { QSpinnerGears } from 'quasar'
import CatalogBaseAccessControl from './CatalogBaseAccessControl.vue'
import CatalogsBaseFormLabels from './CatalogsBaseFormLabels.vue'
import { isFileAllowed, isImageDocument, isVideoDocument } from '../../../../components/File/FileUtils'

export default {
  components: {
    FilesField,
    Video,
    CatalogsRecivier,
    CatalogsBaseFormLabels,
    CatalogBaseAccessControl
  },
  mixins: [journalRecordFilesGroups],
  props: {
    treeCatalogReciver: {
      type: Array,
      default: null
    },
    onlyPreview: {
      type: Boolean,
      default: false
    },
    hideShowPdfMobile: {
      type: Boolean,
      default: false
    },
    dataAccessControl: {
      type: Object,
      default: () => {}
    },
    workAreas: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      loading: false,
      description: null,
      nameLabel: null,
      attributes: null,
      id: null,
      icon: null,
      type: 'catalogs',
      key: null,
      parent: null,
      contentType: null,
      showVideo: false,
      showOffice: false,
      thumbStyle: {
        right: '4px',
        borderRadius: '5px',
        background: '#A9A9A9',
        width: '10px',
        opacity: 1
      },
      category: new FilesGroup({
        key: 'document',
        title: 'Файл',
        readonly: false,
        documentType: null,
        props: null,
        documents: [],
        files: [],
        selectedFiles: []
      }),
      documentPreview: {
        url: null,
        html: null,
        contentType: null,
        loading: false,
        loaded: null
      },
      documentUploadURL: '/service/delta/document/upload',
      videoUrl: null,
      currentFolder: { parentName: '', parentDescr: '', name: '', descr: '' },
      movedReceiver: { name: '', id: null },
      readonly: this.isReadOnly(),
      progress: 0,
      progressLabel: '',
      arrXHR: [],
      enableAccessControl: false,
      showLabels: false,
      amountChangeAccess: 0
    }
  },
  computed: {
    link: function () {
      if (this.attributes && this.attributes.link) {
        const link = this.attributes.link
        return {
          name: link.name && link.name[0],
          tooltip: link.tooltip && link.tooltip[0],
          baseLinkText: link.baseLinkText && link.baseLinkText[0],
          baseLink: link.linkPrefix && link.linkPrefix[0] && link.systemObject && link.systemObject[0] && link.systemObject[0][0] && ((link.linkPrefix[0].startsWith('/') ? '' : '/') +
          link.linkPrefix[0] + '/' + link.systemObject[0][0].id)
        }
      }
      return null
    }
  },
  watch: {
    'dataAccessControl.amountChangeAccess': {
      handler: function (data) {
        this.amountChangeAccess = data
      },
      immediate: true
    },
    id: function (valueId) {
      this.amountChangeAccess = 0
      this.onAbortXHR()
      document.querySelectorAll('video').forEach(function (v) {
        while (v.firstChild) {
          v.removeChild(v.firstChild)
        }
        v.load()
      })
      this.showVideo = false
      this.$set(this.documentPreview, 'url', null)
      this.$set(this.documentPreview, 'html', null)
      this.$set(this.documentPreview, 'contentType', null)
      this.$set(this.documentPreview, 'loading', false)
      this.$set(this.documentPreview, 'loaded', null)
      this.setMovedReceiver({ id: null, name: '...КОРНЕВОЙ КАТАЛОГ' })
      this.$set(this.currentFolder, 'name', '')
      this.$set(this.currentFolder, 'descr', '')
      if (this.type == 'documents' && valueId) {
        this.showVideo = this.contentType && isVideoDocument({ contentType: this.contentType })
        this.$set(this.currentFolder, 'parentName', '')
        this.$set(this.currentFolder, 'parentDescr', '')
        const streamVideo = this.showVideo ? '?streamVideo=true' : ''
        const fileUrl = '/service/fileobj/read/' + valueId + streamVideo
        const docItem = {
          url: fileUrl,
          name: this.nameLabel,
          contentType: this.contentType,
          id: this.id,
          document: { id: valueId /* , contentType: "application/pdf" */ },
          selected: true,
          smallUrl: '/service/delta/document/thumbnail/' + valueId + '/140/140'
        }
        this.$set(this.category, 'documents', [docItem])
        // this.$set(this.category, 'files', [docItem])
        this.$set(this.category, 'selectedFiles', [docItem])
        this.showOffice = (this.contentType && (this.contentType.includes('office') || this.contentType.includes('text/plain') ||
                          this.contentType.includes('pdf') || this.contentType.includes('word') ||
                          this.contentType.includes('excel')))
        if (document.getElementById('img-preview')) {
          document.getElementById('img-preview').style = ''
        }
        if (this.showOffice) {
          this.showOfficeDocuments()
        }
      } else {
        this.$set(this.currentFolder, 'parentName', this.nameLabel)
        this.$set(this.currentFolder, 'parentDescr', this.description)
        this.$set(this.category, 'selectedFiles', [])
        this.$set(this.category, 'files', [])
        this.showOffice = false
        this.showVideo = false
      }
    }
  },
  created: function () {
    this.loading = false
    this.prepareFilesGroups()
  },
  beforeDestroy: function () {
    this.onAbortXHR()
  },
  updated: function () {
    if (this.showVideo) {
      this.videoUrl = this.category.selectedFiles[0].url
    }
  },
  methods: {
    getRecordId: function () {
      return this.id
    },
    prepareFilesGroups: function () {
      this.clearFilesGroups()
      this.filesGroups.push(this.category)

      this.filesGroupsMap = {}
      this.filesGroups.forEach(filesGroup => {
        this.filesGroupsMap[filesGroup.key] = filesGroup
      })
      this.loading = true
      this.loadPreloadedFiles().finally(() => {
        this.loading = false
      })
    },
    onSave: function () {
      const _action = this.type == 'catalogs' ? 'on-save-catalog' : 'on-save-document-in-catalog'
      this.$emit(_action, {
        id: this.id,
        name: this.nameLabel,
        descr: this.description,
        key: this.key,
        control: {
          amount: this.amountChangeAccess,
          props: this.dataAccessControl.newAccess,
          children: (this.dataAccessControl.accessControl && this.dataAccessControl.accessControl.children) ? this.dataAccessControl.accessControl.children : []
        }
      })
    },
    onAdd: function () {
      if (this.type == 'catalogs') {
        if (this.currentFolder.name !== '') {
          this.$refs.refAddCatalog.hide()
          if (this.$d_hasOperation('delta-catalogs-access-control') && this.dataAccessControl.newAccess == undefined) {
            const _newAccess = {}
            this.$set(_newAccess, 'access', !this.dataAccessControl.item || this.dataAccessControl.item.access)
            this.$set(_newAccess, 'fullAccess', !this.dataAccessControl.item || this.dataAccessControl.item.accessControl)
            this.$set(_newAccess, 'parentAccess', 'notUpdate')
            this.$set(_newAccess, 'childrenAccess', false)
            this.$set(this.dataAccessControl, 'newAccess', _newAccess)
          }
          this.$emit('on-add-catalog',
            {
              id: this.id,
              name: this.currentFolder.name,
              descr: this.currentFolder.descr,
              key: this.key,
              control: {
                amount: this.amountChangeAccess > 0 ? this.amountChangeAccess : this.$d_hasOperation('delta-catalogs-access-control'),
                props: this.dataAccessControl.newAccess,
                children: (this.dataAccessControl.accessControl && this.dataAccessControl.accessControl.children) ? this.dataAccessControl.accessControl.children : []
              }
            })
        } else {
          this.$refs.inputCurrentName.$el.focus()
        }
      }
    },
    onClose: function () {
      this.id = null
      this.icon = null
      this.nameLabel = null
      this.description = null
      this.attributes = null
      this.key = null
      this.$emit('on-close')
    },
    onRemove: function () {
      this.$emit('on-remove', { id: this.id, key: this.key, type: this.type, parent: this.parent, useTrash: true })
    },
    uploadFilesHighCatalog: async function (fileWrapper) {
      const url = this.documentUploadURL
      // const fileWrapper = this.filesGroups[0].filesTree[0]._file // TODO ???
      const formData = new FormData()
      const configFormData = {}
      configFormData.originalTime = fileWrapper.originalTime
      if (this.id) {
        configFormData.id = this.id
      }
      const isImage = isImageDocument(fileWrapper.file)
      const isVideo = isVideoDocument(fileWrapper.file)
      const isFileAllowedResult = isFileAllowed(fileWrapper.file, isImage, isVideo)
      if (!isFileAllowedResult.result) {
        this.$q.notify({
          type: 'negative',
          message: isFileAllowedResult.message,
          progress: true,
          timeout: 8000
        })
        this.category.deleteFile(fileWrapper)
        return Promise.reject(Error())
      }
      formData.set('file', fileWrapper.file)
      formData.set('formData', JSON.stringify(configFormData))
      const promise = {
        url: url,
        data: formData,
        config: { headers: { 'Content-Type': 'multipart/form-data', 'Execute-In-Main': 'true' } },
        onSuccess: (response) => {
          return Promise.resolve(response.data)
        },
        onFailure: (response) => {
          this.$q.loading.hide()
          const mes = 'Ошибка загрузки файла!' + (response.message ? ' ' + response.message : '')
          this.$q.notify({
            type: 'negative',
            message: mes,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(response.data)
        },
        msgTarget: this
      }
      return axiosPost(promise)
    },
    onFileAddToUpload: function (fileWrapper) {
      this.$q.loading.show({
        spinner: QSpinnerGears,
        message: 'Загрузка файла...',
        messageColor: 'blue-11',
        spinnerColor: 'blue-11'
      })
      this.loading = true
      const upF = this.uploadFilesHighCatalog(fileWrapper).then(result => {
        if (result) {
          // this.$refs.filesField.onDeleteFileFromUpload(fileWrapper)
          if (result.status == 'success') {
            this.onFileUploadSuccess(result.result, this.category)
            this.category.deleteFile(fileWrapper)
          } else {
            return Promise.reject(Error())
          }
          this.loading = false
          this.$q.loading.hide()
        }
      })
      upF
        .catch(result => {
          this.loading = false
          this.$q.loading.hide()
          if (result && result.message) {
            this.$q.notify({
              type: 'negative',
              message: result.message,
              progress: true,
              timeout: 8000
            })
          }
        })
    },
    onAddFile: function () {
      this.$refs.filesField.onAddFile()
    },
    onFileUploadSuccess: function (document, category) {
      // this.pushFile(document)
      if (document.id) {
        // this.loading = false
        this.$emit('on-add-documents-to-catalog', this.id, document.id, this.key ? this.key : 'new-catalog')
      } else {
        this.$q.loading.hide()
      }
    },
    onDownloadFiles: function () {
      if (this.showVideo) {
        this.$refs.wVideo.onDownloadFile()
      } else if (!this.showOffice) {
        this.$refs.filesField.onDownloadFile(this.category.selectedFiles[0])
      } else {
        downloadFile(this.category.selectedFiles[0].url)
      }
    },
    getFile: async function (url, type = 'pdf') {
      let file = null

      await AXIOS({
        method: 'get',
        url: url,
        responseType: type === 'pdf' ? 'arraybuffer' : ''
      }).then(async response => {
        file = type === 'pdf' ? new File([response.data], this.getFileName(response), { type: 'application/pdf' }) : response.data
      }).catch(error => {
        this.$q.notify({
          type: 'warning',
          message: 'Не удалось загрузить файл, ' + error.message,
          progress: true,
          timeout: 8000
        })
      })
      return file
    },
    getFileName: function (response, xml = false) {
      try {
        const headerLine = !xml ? response.headers['content-disposition'] : response
        const startFileNameIndex = headerLine.indexOf('"') + 1
        const endFileNameIndex = headerLine.lastIndexOf('"')
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex)
        filename = decodeURI(filename)
        return filename
      } catch (ignored) {
      }
    },
    onProgressRead: async function (url = null, type = 'pdf') {
      const xhttp = new XMLHttpRequest()
      const th = this
      xhttp.responseType = type === 'pdf' ? 'arraybuffer' : 'blob'
      th.progress = 0.001
      th.progressLabel = ''
      // th.documentPreview.loaded = '0 байт'
      xhttp.onprogress = async function (e) {
        if (e.lengthComputable) {
          th.documentPreview.loaded = null
          const percentage = Math.round((e.loaded / e.total) * 100)
          th.progress = percentage / 100
          th.progressLabel = percentage + '%'
        } else {
          th.progress = 0
          th.documentPreview.loaded = e.loaded + ' байт'
        }
      }
      xhttp.onload = async function () {
        if (this.status != 200) {
          th.$q.notify({
            type: 'warning',
            message: 'Не удалось загрузить файл для просмотра! HTTP_STATUS:' + this.status + '.' + this.statusText,
            progress: true,
            timeout: 8000
          })
        } else {
          const header = this.getResponseHeader('Content-Disposition')
          // const file = new Blob([this.response], { type: 'application/pdf' })
          const file = type === 'pdf' ? new File([this.response], th.getFileName(header, true), { type: 'application/pdf' }) : new Blob([this.response], { type: 'text/plain' })
          // this.response
          th.documentPreview.url = type === 'pdf' ? URL.createObjectURL(await file) : null
          th.documentPreview.html = type === 'doc' ? await file.text() : null
          if (th.documentPreview.html) {
            th.documentPreview.html = th.documentPreview.html.replaceAll('\n', '<br>')
          }
        }
        th.documentPreview.loaded = null
        th.documentPreview.loading = false
        th.progress = 1
      }
      xhttp.onerror = function () {
        th.$q.notify({
          type: 'warning',
          message: 'Ошибка соединения',
          progress: true,
          timeout: 8000
        })
        th.documentPreview.loaded = null
        th.documentPreview.loading = false
        th.progress = 0
      }

      this.arrXHR.push(xhttp)
      xhttp.open('GET', url || this.category.selectedFiles[0].url, true)
      xhttp.send()
    },
    showPdfMobile: function () {
      this.$d_pdfViewer.show({
        files:
                [
                  {
                    src: this.category.selectedFiles[0],
                    name: this.nameLabel
                  }
                ],
        mergeFiles: true
      })
    },
    showOfficeDocuments: async function () {
      this.documentPreview.loading = true
      if (this.contentType) {
        if (this.contentType.includes('pdf')) {
          this.documentPreview.contentType = 'application/pdf'
          if (!this.hideShowPdfMobile && this.$store.getters.getUser.view === 'mobile') {
            this.showPdfMobile()
            this.$set(this.documentPreview, 'loading', false)
          }
          this.onProgressRead()
        } else if (this.contentType.includes('text/plain')) {
          const fileWrapper = this.category.selectedFiles[0]
          const fileURL = '/service/fileobj/content/' + fileWrapper.id
          // this.documentPreview.html = await this.getFile(fileURL, 'doc')
          this.onProgressRead(fileURL, 'doc')
          this.documentPreview.contentType = 'text/plain'
        } else if (this.contentType.includes('word') || this.contentType.includes('office') || this.contentType.includes('excel')) {
          const fileWrapper = this.category.selectedFiles[0]
          const fileURL = '/service/fileobj/content/' + fileWrapper.id + '?convert=html'
          // this.documentPreview.html = await this.getFile(fileURL, 'doc')
          this.onProgressRead(fileURL, 'doc')
          this.documentPreview.contentType = 'text/html'
        }
      }
      // this.documentPreview.loading = false
    },
    onShowFile: function () {
      // если видео, то др. viewer
      this.$refs.filesField.onShowFile(this.category.selectedFiles[0])
    },
    onShowAdd: function (e) {
      this.$refs.inputCurrentName.$el.focus()
    },
    onCopy: function () {
      if (this.type == 'catalogs') {
        this.$emit('on-copy', this.id)
      } else {
        this.$emit('on-add-documents-to-catalog', null, this.id, this.key, true, this.movedReceiver.name)
      }
    },
    isReadOnly: function () {
      const isMobile = this.$store.getters.getUser.view === 'mobile'
      const permission = this.$d_hasOperation('delta-catalogs-management')
      return isMobile || !permission
    },
    onRotateImg: function () {
      this.$nextTick(() => {
        const img = document.getElementById('img-preview')
        const rotateAngle = Number(img.getAttribute('rotangle')) + 90
        img.style.transform = 'rotate(' + rotateAngle + 'deg)'
        img.setAttribute('rotangle', +rotateAngle)
      })
    },
    setMovedReceiver: function (data) {
      this.movedReceiver = { name: data.name, id: data.id }
      this.$emit('set-moved-id', data.id)
    },
    onPrintDoc: function () {
      const testProgress = (this.progress > 0 && this.progress < 1)
      if (this.contentType.includes('image')) {
        AXIOS({
          method: 'GET',
          url: '/service/delta/document/read?id=' + this.id,
          responseType: 'arraybuffer'
        }).then(response => {
          const file = new Blob([response.data], { type: 'image/jpeg' })
          const el = document.createElement('img')
          const imageURL = URL.createObjectURL(file)
          el.src = imageURL
          const printEl = document.createElement('iframe')
          document.body.appendChild(printEl)
          printEl.contentWindow.document.open()
          printEl.contentWindow.document.write(el.outerHTML)
          setTimeout(() => {
            printEl.contentWindow.focus()
            printEl.contentWindow.print()
            printEl.contentWindow.document.close()
            printEl.remove()
          }, 1000) // needed for chrome to load images, check out https://bugs.chromium.org/p/chromium/issues/detail?id=1288401&q=image%20print%20iframe&can=2
        })
      } else {
        const el = this.contentType.includes('pdf') ? document.getElementById('object-' + this.id) : document.getElementById('iframe' + this.id)
        if (el && !this.contentType.includes('pdf') && !testProgress) {
          el.contentWindow.focus()
          el.contentWindow.print()
        } else if (el && this.contentType.includes('pdf') && !testProgress) {
          const wPdf = window.open(el.data)
          wPdf.print()
        } else {
          this.$q.notify({
            type: 'negative',
            message: 'Файл не готов к печати',
            progress: true,
            timeout: 8000
          })
        }
      }
    },
    onAbortXHR: function () {
      if (this.arrXHR.length) {
        for (let i = 0; i < this.arrXHR.length; i++) {
          this.arrXHR[i].abort()
        }
        this.arrXHR.length = 0
      }
    },
    toogleEnableAccessControl: function () {
      if (this.$d_hasOperation('delta-catalogs-access-control')) {
        this.enableAccessControl = !this.enableAccessControl
      }
    },
    onChangeAccess: function (item) {
      this.amountChangeAccess = item.amount
      this.$set(this.dataAccessControl, 'newAccess', item.props)
      this.$set(this.dataAccessControl, 'amountChangeAccess', item.amount)
    }
  }
}
